import LoginComponent from '../login-component';
import {localize} from '../../infrastructure/localization';

export default class LoginSubmitButton extends LoginComponent {

    constructor(props) {
        super(props);
    }

    get error() {
        return this.state.loginModel.validation.errors.submitError;
    }

    render () {
        return (
            <div className="btn-submit-placeholder">
                <div className="submit-error">{this.error}</div>
                <button type="submit" className="btn btn-submit">
                    {localize('forms.login.submit')}
                </button>
            </div>
        )
    }
};


/** WEBPACK FOOTER **
 ** ./src/components/form-components/login-submit-button.jsx
 **/